'use strict';

var ProfileChartAddFlightModalDirective = function ProfileChartAddFlightModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-add-flight-modal.html'),
    controller: 'ProfileChartAddFlightModalController',
    link: function link($scope, element) {
      $scope.hideModal = function () {
        element.modal('hide');
      };
      element.on('shown.bs.modal', function () {
        $scope.populateDropdowns();
      });
    }
  };
};
ProfileChartAddFlightModalDirective.$inject = [];
module.exports = ProfileChartAddFlightModalDirective;